<template>
  <v-select filled v-model="operator" :items="filterOperators" :hide-details="hideDetails" :label="$t('selector.operator')"></v-select>
</template>
<script>
export default {
  name: 'OperatorSelector',
  props: {
    value: {
      type: Number
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    avilableOpList: {
      type: Array,
      default: () => ([1,2,3,4,5,6])
    }
  },
  data() {
    return {
      allOperators: [
        {
          text: '>=',
          value: 1
        },
        {
          text: '>',
          value: 2
        },
        {
          text: '<=',
          value: 3
        },
        {
          text: '<',
          value: 4
        },
        {
          text: '=',
          value: 5
        },
        {
          text: '≠',
          value: 6
        },
      ]
    }
  },
  computed: {
    operator: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', val);
      }
    },
    filterOperators() {
      return this.allOperators.filter(o => this.avilableOpList.includes(o.value));
    }
  }
}
</script>